import { createContext, useContext } from 'react';

export const PAY_PATH = /^\/(tariflar|tolov|tolovlar|qayta-aloqa)(\/|$)/;

export const CoveredContext = createContext(false);

export const useCovered = (): boolean => useContext(CoveredContext);

export const InSheetContext = createContext(false);

export const useInSheet = (): boolean => useContext(InSheetContext);
